import * as Sentry from '@sentry/react';
import { ENV } from './env';

/**
 * Sentry init. Only enabled on production + staging — Vercel preview deploys
 * skip Sentry entirely so per-PR noise doesn't pollute the project (plan §6).
 */
export function initSentry(): void {
  if (!ENV.sentryDsn) return;
  if (ENV.vercelEnv === 'preview' || ENV.vercelEnv === 'development') return;

  Sentry.init({
    dsn: ENV.sentryDsn,
    release: ENV.release,
    environment: ENV.vercelEnv || ENV.mode || 'production',
    tracesSampleRate: ENV.isProd ? 0.2 : 1.0,
    integrations: [Sentry.browserTracingIntegration()],
    // Filter out errors we can't act on (extension noise, network blips).
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection captured',
      /^Network request failed/i,
    ],
  });
}

export { Sentry };
